"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _basicCard = require("./basicCard");

var _basicCard2 = _interopRequireDefault(_basicCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _basicCard2.default;